/**
 * How SignaalitList renders source groups.
 *
 * Split out so bun:test can cover the policy without a DOM (same pattern as
 * signal-tree-expand.ts). Building-wide Signaalit keeps the accordion. Nested in
 * a parent panel that already names the selection, the accordion is waste: the
 * group header repeats the parent, and rows stay hidden until the header is
 * clicked. One visible group → no header at all. Several groups (a zone with
 * its own signals plus serving equipment) keep a static, always-open header so
 * sources stay distinguishable without an extra click.
 */
export type SignalGroupChrome = "accordion" | "static" | "flat";

export function signal_group_chrome(
  embedded: boolean,
  group_count: number,
): SignalGroupChrome {
  if (!embedded) return "accordion";
  if (group_count <= 1) return "flat";
  return "static";
}
